// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__8kIfc","content":"LayoutSettings_content__2atzA"};